import { cn } from '@/lib/utils';

/*
 * Logo chính thức Minh Tiến (Design System v2.0 §1, §5) – chỉ dùng file ảnh gốc, KHÔNG vẽ lại bằng CSS/chữ,
 * không đổi màu, không bóp méo (luôn object-contain, giữ tỷ lệ).
 * Nguồn: docs/ui/brand/logo-chuan-minh-tien.jpg → public/logo.png (logo đầy đủ), public/logo-mark.png (phần MT).
 */

/** Phần "MT" của logo chính thức. */
export function LogoMark({ className }: { className?: string }) {
  return <img src="/logo-mark.png" alt="" aria-hidden="true" className={cn('size-9 shrink-0 object-contain', className)} />;
}

/** Logo đầy đủ (MT + Minh Tien + slogan). Đặt trên nền `bg-logo-surface` để đúng màu ở cả chế độ Tối. */
export function LogoFull({ className }: { className?: string }) {
  return <img src="/logo.png" alt="Minh Tiến – Let's go together" className={cn('h-auto object-contain', className)} />;
}

/** Khối nhận diện ở sidebar/header: Logo Mark + tên hệ thống (chữ thường, màu theo nền – không giả lập logo chữ). */
export function Logo({ className, sub = 'Hệ thống quản lý bán hàng', compact }: { className?: string; sub?: string | false; compact?: boolean }) {
  return (
    <div className={cn('flex min-w-0 items-center gap-2.5', className)}>
      <LogoMark />
      {!compact && (
        <div className="min-w-0 leading-none">
          <div className="truncate text-[15px] font-bold tracking-tight">Minh Tiến ERP</div>
          {sub && <div className="mt-1 truncate text-[10px] tracking-wide opacity-70">{sub}</div>}
        </div>
      )}
    </div>
  );
}
